import { useCallback } from "react";
import { axiosStructurePartnerWithoutInterceptor } from "./axios";

export interface IUpdateStructurePartnerBody {
  name?: string;
  notDomiciled?: boolean;
  place?: string;
  website?: string;
  comment?: string;
  privileged?: boolean;
  contacts?: string[];
}

export const useUpdateStructurePartner = () => {
  const [state, execute, cancel] = axiosStructurePartnerWithoutInterceptor<void, IUpdateStructurePartnerBody>(
    {
      method: "PUT",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (_id: string, data: IUpdateStructurePartnerBody) => {
      return execute({
        url: _id,
        data,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
